const YASH_HUBSPOT_MEETING_LINK = 'https://meetings.hubspot.com/ycee/strategy-session';
const JIM_HUBSPOT_MEETING_LINK = 'https://meetings.hubspot.com/jim-tanevski';
const JIM_HUBSPOT_STRATEGY_MEETING_LINK = 'https://meetings.hubspot.com/jim-tanevski/trial-wins-workshop';
const DEFAULT_HUBSPOT_MEETING_LINK = 'https://meetings.hubspot.com/ycee/strategy-session';
export { YASH_HUBSPOT_MEETING_LINK, JIM_HUBSPOT_MEETING_LINK, JIM_HUBSPOT_STRATEGY_MEETING_LINK, DEFAULT_HUBSPOT_MEETING_LINK, };
